<template>
  <span :class="$style.label">
    <template v-for="(segment, i) in segments" :key="i">
      <span v-if="typeof segment === 'object'" :class="$style.highlight">{{ segment.highlight }}</span>
      <template v-else>{{ segment }}</template>
    </template>
  </span>
</template>

<script setup lang="ts">
import { highlightMatch } from "@scayla/core";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    text?: string | number | boolean | string[] | null | undefined;
    searchTerm?: string;
    startLength?: number;
  }>(),
  {
    text: "",
    searchTerm: "",
    startLength: 0,
  },
);

const segments = computed(() => {
  let valueStr = "";
  if (props.text == null) {
    valueStr = "";
  } else if (typeof props.text === "string" || typeof props.text === "number") {
    valueStr = String(props.text);
  } else if (typeof props.text === "boolean") {
    valueStr = props.text ? "true" : "false";
  } else if (Array.isArray(props.text)) {
    valueStr = props.text.join(", ");
  } else {
    valueStr = "";
  }

  if (!props.searchTerm || (props.startLength !== undefined && props.searchTerm.length <= props.startLength)) {
    return [valueStr];
  }
  return highlightMatch(valueStr, props.searchTerm);
});
</script>

<style module lang="scss">
.highlight {
  background-color: var(--color-action-primary-subtle-selected);
  padding: 0px;
  border-radius: 2px;
}
</style>
